<ng-container *transloco="let t">
  <p class="label" [ngClass]="{'invalid': IsInValid()}">{{label}}</p>
  <div class="input-container">
    <input type="{{type}}" class="input" [ngClass]="{'invalid': IsInValid()}" [formControl]="control" [placeholder]="label">
    <app-svg-icon class="icon" [path]="'/assets/eye.svg'" (click)="togglePassword()"></app-svg-icon>
  </div>
  <div *ngIf="IsInValid()" class="error">
    <img src="/assets/warning.png">
    <p>{{ t('COMMON.INPUT.TEXT.ERROR-PREFIX') }}{{label.toLowerCase()}}</p>
  </div>
</ng-container>
